import Vue from 'vue';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import { LOAD_CLAIMS, RESET_CLAIMS } from "../const/claims";
import {
  ADD_BLACK_LIST_REQUISITE,
  ADD_BLACK_LIST_USER, DELETE_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_USER, LOAD_EXCHANGE_SETTINGS,
  LOAD_BLACK_LIST_REQUISITES,
  LOAD_BLACK_LIST_USERS, EDIT_EXCHANGE_SETTINGS, ADD_USER_NOTE, DELETE_USER_NOTE,
} from '../const/exchange';

export default {
  namespaced: true,
  state: {
    blackListUsers: {
      list: [],
      pagination: {},
    },
    blackListRequisites: {
      list: [],
      pagination: {},
    },
  },
  getters: {
    blackListUsers: state => state.blackListUsers,
    blackListRequisites: state => state.blackListRequisites,
  },
  actions: {
    [LOAD_EXCHANGE_SETTINGS]: async ({ dispatch }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_EXCHANGE_SETTINGS,
        namespace: 'exchange',
        no_commit: true,
      }, {root: true});
      return request;
    },
    [EDIT_EXCHANGE_SETTINGS]: async ({ dispatch }, body) => {
      const request = await dispatch(HTTP_PUT, {
        method: LOAD_EXCHANGE_SETTINGS,
        namespace: 'exchange',
        body,
        no_commit: true,
      }, {root: true});
      return request;
    },
    [LOAD_BLACK_LIST_USERS]: async ({ dispatch, commit }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_BLACK_LIST_USERS,
        namespace: 'exchange',
        params,
      }, {root: true});
    },
    [ADD_BLACK_LIST_USER]: async ({ dispatch }, body) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_BLACK_LIST_USER,
        namespace: 'exchange',
        body,
        no_commit: true,
      }, {root: true});
      return request;
    },
    [DELETE_BLACK_LIST_USER]: async ({ dispatch }, value) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_BLACK_LIST_USER,
        namespace: 'exchange',
        body: { value },
        no_commit: true,
      }, {root: true});
      return request;
    },
    [LOAD_BLACK_LIST_REQUISITES]: async ({ dispatch, commit }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_BLACK_LIST_REQUISITES,
        namespace: 'exchange',
        params,
      }, {root: true});
    },
    [ADD_BLACK_LIST_REQUISITE]: async ({ dispatch }, body) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_BLACK_LIST_REQUISITE,
        namespace: 'exchange',
        body,
        no_commit: true,
      }, {root: true});
      return request;
    },
    [DELETE_BLACK_LIST_REQUISITE]: async ({ dispatch }, value) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_BLACK_LIST_REQUISITE,
        namespace: 'exchange',
        body: { value },
        no_commit: true,
      }, {root: true});
      return request;
    },
    [ADD_USER_NOTE]: async ({ dispatch }, body) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_USER_NOTE,
        namespace: 'exchange',
        body,
        no_commit: true,
      }, { root: true });
      return request;
    },
    [DELETE_USER_NOTE]: async ({ dispatch }, user) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_USER_NOTE,
        namespace: 'exchange',
        body: { user },
        no_commit: true,
      }, { root: true });
      return request;
    },
  },
  mutations: {
    [LOAD_BLACK_LIST_USERS]: (state, { data }) => {
      Vue.set(state.blackListUsers, 'list', data.list);
      Vue.set(state.blackListUsers, 'pagination', data.pagination);
    },
    [LOAD_BLACK_LIST_REQUISITES]: (state, { data }) => {
      Vue.set(state.blackListRequisites, 'list', data.list);
      Vue.set(state.blackListRequisites, 'pagination', data.pagination);
    },
    [RESET_CLAIMS]: (state) => {
      Vue.set(state, 'claims', {
        claims: [],
        pagination: {},
      });
    },
  },
};
